import axios from "@/CommonDP/utils/request";
export function dyn_custom_page_saveOrUpdate(data) {
  return axios({ url: 'dyn-custom-page/saveOrUpdate', method: 'post', data });
}
export function dyn_custom_page_list(groupId) {
  return axios({ url: `dyn-custom-page/list/${groupId}` });
}
export function dyn_custom_page_batchDelete(data) {
  return axios({ url: `dyn-custom-page/batchDelete`, method: 'post', data });
}
